import { useContext } from "react";
import { DeclarationContext } from "../components/context/DeclarationWrapper";

export const usePeriodAvailability = () => {
  const { availablePeriods, periodsForSelects, periodsLoading, periodsError } = useContext(DeclarationContext);

  const isMonthAvailable = (year, month) => {
    if (!availablePeriods) return true;
    if (!availablePeriods.monthly) return false;
    const yearStr = year.toString();
    return availablePeriods.monthly[yearStr]?.includes(month) ?? false;
  };

  const isSemesterAvailable = (year, semester) => {
    if (!availablePeriods) return true;
    if (!availablePeriods.semiAnnual) return false;
    const yearStr = year.toString();
    return availablePeriods.semiAnnual[yearStr]?.includes(semester) ?? false;
  };

  const isYearAvailable = (year) => {
    if (!availablePeriods) return true;
    if (!availablePeriods.annual) return false;
    return availablePeriods.annual.includes(year);
  };

  const hasAnyMonthlyAvailable = () => {
    if (!availablePeriods?.monthly) return true;
    return Object.values(availablePeriods.monthly).some(months => months.length > 0);
  };

  const hasAnySemiAnnualAvailable = () => {
    if (!availablePeriods?.semiAnnual) return true;
    return Object.values(availablePeriods.semiAnnual).some(semesters => semesters.length > 0);
  };

  const hasAnyAnnualAvailable = () => {
    if (!availablePeriods?.annual) return true;
    return availablePeriods.annual.length > 0;
  };

  const getUnavailableMessage = (type, year, period = null) => {
    switch (type) {
      case "monthly":
        return `Une déclaration mensuelle existe déjà pour cette période`;
      case "semiAnnual":
        return `Une déclaration semestrielle existe déjà pour cette période`;
      case "annual":
        return `Une déclaration annuelle existe déjà pour cette période`;
      default:
        return `Une déclaration existe déjà pour cette période`;
    }
  };

  return {
    availablePeriods,
    periodsForSelects,
    periodsLoading,
    periodsError,
    isMonthAvailable,
    isSemesterAvailable,
    isYearAvailable,
    hasAnyMonthlyAvailable,
    hasAnySemiAnnualAvailable,
    hasAnyAnnualAvailable,
    getUnavailableMessage,
  };
};
